import { ErrorBoundary } from '@libs/core';
import { store } from '@libs/store';
import { isProduction } from '@libs/utils';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { createBrowserRouter, RouterProvider } from 'react-router';
import router from './app/router/router';
import './main.css';

if ('serviceWorker' in navigator && isProduction()) {
    navigator.serviceWorker
        .register('service-worker.js')
        .then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
            console.error('Service Worker registration failed:', error);
        });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Provider store={store}>
        <StrictMode>
            <ErrorBoundary>
                <RouterProvider
                    router={createBrowserRouter(router, {
                        basename: process.env.NX_PUBLIC_BASE_URL || '/',
                    })}
                />
            </ErrorBoundary>
        </StrictMode>
    </Provider>,
);
